import { styled as StyledMui } from "@mui/system";
import { Box, Typography, Button } from "@mui/material";
import { laptopMQL } from "../../utils/constant";

export const ConnectionsHomeContainer= StyledMui(Box)(() => ({
    height: "75vh",
    overflowY: "scroll",
    overflowX: "hidden",
    "@media only screen and (max-width: 900px)":{
      height: "calc(100vh - 128px)",
     },
}));
export const ConnectionsHomeBox = StyledMui(Box)(() => ({
  maxWidth: "95rem",
  margin: "10rem auto 0",
  display: "flex",
  flexDirection: "column",
  rowGap: "6.5rem",
  paddingBottom:"5rem",
  [laptopMQL]:{
    margin: "4rem auto 0",
    rowGap: "4.5rem",
  },
  "@media only screen and (max-width: 900px)":{
    padding:"0 4rem 5rem 4rem"
  },
  "@media only screen and (max-height: 763px)":{
    margin: "3rem auto 0",
  },
}));

export const ConnectionsHomeAddConnectionBox = StyledMui(Box)(() => ({
  backgroundColor: "#F2F2F2",
  borderRadius: "1rem",
  display: "flex",
  flexWrap:"wrap",
  columnGap: "11rem",
  justifyContent: "center",
  alignItems: "center",
  padding: "3.5rem 4.2rem 3.5rem 6rem",
  [laptopMQL]:{
    padding: "2.5rem 3.5rem 2.5rem 5rem",
  },
  "@media only screen and (max-width: 900px)":{
   margin:"0 auto",
   rowGap:"2rem"
  },
}));
export const ConnectionsHomeAddConnectionText = StyledMui(Typography)(() => ({
  width: "48rem",
  textAlign: "left",
  color: "#64666A",
  "@media only screen and (max-width: 900px)":{
    width:"100%",
    maxWidth:"48rem"
   },
}));

export const ConnectionsHomeAddConnectionButton = StyledMui(Button)(({ theme }) => ({
        padding: "1rem 2.5rem",
        fontSize: "1.7rem",
        fontWeight: "500",
        textWrap: "nowrap",
        textOverflow:"ellipsis",
        overflow: "hidden",
        color: theme.bniRed.main,
        background: theme.trueWhite.main,
        borderRadius: "1rem",
        boxShadow: "8px 8px 10px 0px rgba(0,0,0,0.1)",
        "svg":{
            fill:theme.bniRed.main 
          },
        "&:hover,&:focus": {
          background: theme.bniRed.main,
          color: theme.sterlingLightGrey.main,
          boxShadow: "8px 8px 10px 0px rgba(0,0,0,0.1)",
          "svg":{
            fill:theme.trueWhite.main, 
          }
        },
        direction:theme.direction,
        ".MuiButton-startIcon":{
          marginRight:theme.direction==="rtl"?"-0.4rem":"1.6rem",
          marginLeft:theme.direction==="rtl"?"1.6rem":"-0.4rem",
        }
}));

export const ConnectionsHomeCardsBox = StyledMui(Box)(() => ({
  display: "flex", 
  justifyContent:"space-between",
  gap:"3rem",
  flexWrap:"wrap",
  "@media only screen and (max-width: 746px)":{
    justifyContent:"space-evenly",
  },
}));
